import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { Router } from '@angular/router';
import { RouteManagerService } from './services/route-manager.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    logged = false;

    constructor(
        public router: Router,
        private routeManager: RouteManagerService
    ) { }

    ngOnInit() {
        this.firebaseInitializeApp();
    }

    firebaseInitializeApp() {
        firebase.initializeApp(environment.firebase);

        firebase.auth().onAuthStateChanged(async user => {
            if (user) {
                this.logged = true;
            } else {
                this.logged = false;
            }
        });

        this.router.navigateByUrl('/login');
    }
}
